import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { ViajesService } from 'src/app/_services/viajes.service';
import { ModalCategoriaHotelComponent } from '../modal-categoria-hotel/modal-categoria-hotel.component';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';

interface Habitacion {
  name: string,
  value: string,
  check: boolean,
};

@Component({
  selector: 'app-tours-create',
  templateUrl: './tours-create.component.html',
  styleUrls: ['./tours-create.component.css']
})

export class ToursCreateComponent implements OnInit, OnDestroy {
  year: number;
  form1: FormGroup;
  form2: FormGroup;
  //submitted1 = false;
  submitted2 = false;
  guardado = false;
  idViaje: string = '0';
  //imagenes: any;
  //file = false;
  tipoTransporte: string;
  protected asientosSubscription: Subscription;
  asientos: string[];
  bdTransporte: any;
  passAsientos: string;
  bloqueado: number;
  asientosSelected: string[];
  errorAsientos: string;
  protected categoriaSubscription: Subscription;
  categoria: number = 3;
  localUrl: any[];
  ext: string;
  file = false;
  checked = false;
  id_hotel: string;
  tipoHabitacion:  Habitacion[];  
  tipoCama = [];
  imagenesbd= [];
  showInput = true;

  fileToBig = false;
  fileToBig2 = false;

  dias:number[] = [];
  

  constructor(
    private formBuilder: FormBuilder,
    private viajesService: ViajesService,
    private auxService: AuxiliarService,
    private router: Router,
    private modalService: NgbModal,
    private chdRef: ChangeDetectorRef
  ) { }


  ngOnInit(): void {
    this.year = new Date().getFullYear();
    this.passAsientos = '';
    this.asientosSelected = [];
    this.asientos = []; 
    this.errorAsientos = '';
    this.bloqueado = 0;
    //Crear form1
    this.form1 = this.formBuilder.group({      
      nombre: ['', Validators.required], 
      descripcion: ['', Validators.required],         
    });  
    //Crear form2
    this.form2 = this.formBuilder.group({
      imagenes: this.formBuilder.array([], [Validators.required]),
      destino: ['', Validators.required], 
      mes: ['default'],
      dia: ['default'],
      anno: ['default'],  
      salida: ['', Validators.required],
      noches: ['', Validators.required],
      detalles: ['', Validators.required],         
      desde: ['', Validators.required],
      hasta: ['', Validators.required],
      transporte: ['default'], 
      hotel: ['', Validators.required], 
      //imagen:  [, Validators.required],
      checkHabitacion: this.formBuilder.array(["1", "2"], [Validators.required]),
      checkCama: this.formBuilder.array(["1", "2"], [Validators.required]),
      Individual: ['', Validators.required],
      Doble:['', Validators.required],
      Triple:['', Validators.required],
      Cuadruple:['', Validators.required],
    }, { validators: [
          this.ConfirmedValidator('mes', 'anno', 'dia'), 
          this.transporteValidator('transporte'),
          this.rangoEdadValidator('desde', 'hasta'),
          this.precioValidator('Individual'),
          this.precioValidator('Doble'),
          this.precioValidator('Triple'),
          this.precioValidator('Cuadruple'),
        ]
      });

      this.form2.get("mes").valueChanges.subscribe(value=>{
        var lastValue = (value == 1 || value == 3 || value == 5 || value == 7 || value == 8 || value == 10 || value == 12) ? 31 : 30;
        if(value == 2){
          lastValue = 28;
        }
        for(var i = 1; i <= lastValue; i++){
          this.dias.push(i);
          this.chdRef.detectChanges();
        }
      })
    //Obtener tipo de habitacion    
    this.viajesService.getTipoHabitacion().subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.length > 0){
          var habitaciones = data.body;   
          var list= [];
          for (let i in habitaciones) { 
            var check = (habitaciones[i].tipo === 'Individual' || habitaciones[i].tipo === 'Doble')?true:false;                       
            list.push({ name: habitaciones[i].tipo, value: habitaciones[i].id, check: check });                      
          } 
          this.tipoHabitacion = list;
        }    
      }
    }); 
    ////obtener tipo transporte
    this.viajesService.getTipoTransporte().subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        var response = data.body;
        this.bdTransporte = response;                             
      }
    }); 
    //suscripciones
    this.asientosSubscription = this.viajesService.asientos.subscribe((data: any) => { 
      if(data !== undefined){
        this.asientos = data;
        this.errorAsientos = '';
      }
    });
    this.categoriaSubscription = this.viajesService.categoria_hotel.subscribe((data: any) => { 
      this.categoria = data;    
    });
    //obtener tipo de cama
    this.viajesService.getTipoCama().subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.length > 0){
          var tipoCamas = data.body;   
          var list= [];
          for (let i in tipoCamas) { 
            list.push({ name: tipoCamas[i].tipo, value: tipoCamas[i].id });                      
          } 
          this.tipoCama = list;
        }    
      }
    });        
  }
  ConfirmedValidator(controlName1: string, controlName2: string, controlName3: string){
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName1];
        const control1 = formGroup.controls[controlName2];  
        const control2 = formGroup.controls[controlName3];        
        if ( control.value === "default" || control1.value === "default" || control2.value === "default") {
            control.setErrors({ confirmedValidator: true });
        } 
        else { 
          control.setErrors(null);
        }
    }   
  }
  rangoEdadValidator(controlName1: string, controlName2: string){
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName1];
        const control1 = formGroup.controls[controlName2];        
        if ( (control.value !== '') && (control1.value !== '') && (parseInt(control.value) > 20 || parseInt(control.value) < 0) 
              || (parseInt(control1.value) > 20 || parseInt(control1.value) < 0)
              || (parseInt(control.value) >= parseInt(control1.value))) {
            control1.setErrors({ rangoEdadValidator: true });
        } 
        /*else { 
          control.setErrors(null);
        }*/
    }   
  }
  transporteValidator(controlName: string){
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      if (control.value === "default") {
        control.setErrors({ transporteValidator: true });
      } else { 
        control.setErrors(null);
      }  
    }   
  }
  precioValidator(controlName: string){
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      if (control.value  < 1) {
        control.setErrors({ precioValidator: true });
      } else { 
        control.setErrors(null);
      }  
    }       
  }
 
  keypressValue(event){
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57));
  }

  get f() { return this.form1.controls; }
  get f1() { return this.form2.controls; }

  //Help to get all photos controls as form array.
  get imagenes(): FormArray {
    return this.form2.get('imagenes') as FormArray;
  };
  // We will create multiple form controls inside defined form controls photos.
  createItem(data): FormGroup {

   

    var form = this.formBuilder.group(data);
    return form
    
  }
  deleteItem(data){
    this.imagenes.removeAt(data);
    this.fileToBig2 = false;
    for (let control of this.imagenes.controls) {
     if(control.value.toBig){
       this.fileToBig2 = true;
     }
    }
  }
  

  fileEvent(fileInput: any){    
    let files = fileInput.target.files;
    if (files) {
      for (let file of files) {
        let reader = new FileReader();
        let arr = file.name.split('.');
        let ext = arr[arr.length-1].toLowerCase();
        if(ext==='jfif') ext = 'jpg';
        reader.onload = (e: any) => {
          this.imagenes.push(this.createItem({                    
                  //ext: ext,
                  toBig: file.size/1024/1024 > 2 ? true : false,
                  url: e.target.result  //Base64 string for preview image
                }));
          
                var array:any [] = this.imagenes.controls as [];
                this.fileToBig2 = false;
                array.forEach((e)=>{
                  if(e.value.toBig){
                    this.fileToBig2 = true;
                  }
                });
          }
          
          reader.readAsDataURL(file);
        
        }
        if(this.showInput) {
          this.showInput = false;
        } else { 
          this.showInput = true;
        }

        
        
    }  
        
    

    
    
  }
  changeTransporte(){
    for (let i in this.bdTransporte){
      if(this.bdTransporte[i].id == this.form2.get('transporte').value){
        this.tipoTransporte = this.bdTransporte[i].tipo;  
        return;
      }
    }       
  }
  fileEvent2(fileInput: any){
    this.fileToBig = false;
    if (fileInput.target.files[0].size/1024/1024 > 2) {
      console.log('file is bigger than 2MB');
      this.fileToBig = true;
      this.file = true; 
      var reader = new FileReader();
       reader.onload = (fileInput: any) => {
           this.localUrl = fileInput.target.result  
           this.file = true;                      
       }
      reader.readAsDataURL(fileInput.target.files[0]); 
      this.form2.get('imagen').setValue(null);
    }else{
      if (fileInput.target.files.length > 0) {
        const file = fileInput.target.files[0];
        this.ext = file.name.split('.')[1],
        this.form2.get('imagen').setValue(file);
      }    
      var reader = new FileReader();
       reader.onload = (fileInput: any) => {
           this.localUrl = fileInput.target.result  
           this.file = true;                      
       }
     reader.readAsDataURL(fileInput.target.files[0]);  
    }
    
  } 
  /*
  eliminarImagen(){    
    this.file = false;
    this.localUrl = [];
  }*/
  openCategoria() {
    const modalRef = this.modalService.open(ModalCategoriaHotelComponent, { 
      centered: true,  
      backdrop:'static',      
    });       
  }

  habilitarControlesOcultos(){
    //Habilitar controles ocultos
    this.f1.Individual.enable();
    this.f1.Doble.enable();
    this.f1.Triple.enable();
    this.f1.Cuadruple.enable();
  }
  obtenerImagenesBD(){
    this.viajesService.getImagenes(this.idViaje, '0').subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.length > 0){
          var img = data.body;
         // this.imagenesbd = [];          
          for (let i in img) {                       
            this.imagenes.push(this.createItem({                    
              //ext: ext,
              url: img[i].imagen  //Base64 string for preview image
            }));            
          }                 
        } 
      }
    });
  }
  onSubmit2() {    
    
    this.submitted2 = true;
    //Deshabilitar controles ocultos
    for (let i in this.tipoHabitacion){
      if(!this.tipoHabitacion[i].check){
        if(this.tipoHabitacion[i].name === 'Individual'){
          this.f1.Individual.disable();
        }
        if(this.tipoHabitacion[i].name === 'Doble'){
          this.f1.Doble.disable();
        }
        if(this.tipoHabitacion[i].name === 'Triple'){
          this.f1.Triple.disable();
        }
        if(this.tipoHabitacion[i].name === 'Cuadruple'){
          this.f1.Cuadruple.disable();
        }
      }      
    }
    // stop here if form is invalid
    /*if(!this.asientos.length) {
      this.errorAsientos = 'Asientos requeridos';
      return;
    }*/
   
    if (this.form1.invalid || this.form2.invalid || this.fileToBig || this.fileToBig2) {     
      if(this.fileToBig || this.fileToBig2){
        const modalRef = this.modalService.open(ModalMsgComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        modalRef.componentInstance.titulo = 'Existen imagenes mayores de 2MB';
        modalRef.componentInstance.label = 'Volver';
        return;
      } 
      this.habilitarControlesOcultos();
      const modalRef = this.modalService.open(ModalMsgComponent, { 
        centered: true,  
        backdrop:'static',      
      });
      modalRef.componentInstance.titulo = 'Falta completar información';
      modalRef.componentInstance.label = 'Volver';
      return;
    }
    
    //obtener habitaciones
    var list=[]; 
    for (let i in this.tipoHabitacion){
      if(this.tipoHabitacion[i].check){
        if(this.tipoHabitacion[i].name === 'Individual'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Individual.value       
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Doble'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Doble.value         
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Triple'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Triple.value        
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Cuadruple'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Cuadruple.value       
          }
          list.push(habitacion);
        }
      }      
    }
    //guardar el hotel
    if (this.guardado === false && this.idViaje==='0'){
      //this.viajesService.insertarHotel(this.f1.hotel.value , this.categoria.toString(), this.f1.checkCama.value, this.f1.imagen.value).subscribe(data => {
      this.viajesService.insertarHotel(this.f1.hotel.value , this.categoria.toString(), this.f1.checkCama.value).subscribe(data => {
        if(data instanceof HttpResponse) { 
          //verificar token
          if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
            this.auxService.sessionExpired();
          }
          //acciones
          this.id_hotel=data.body.data.id;
          this.viajesService.insertarHabitaciones(this.id_hotel, list).subscribe(data => {
            if(data instanceof HttpResponse) { }    
          }); 
          var cadena=this.asientos.join('*');
          this.viajesService.createData(this.f.nombre.value, this.f.descripcion.value, this.f1.destino.value ,this.f1.dia.value ,this.f1.mes.value, this.f1.anno.value, this.f1.salida.value, this.f1.noches.value,
            this.f1.detalles.value, this.f1.desde.value, this.f1.hasta.value, this.f1.transporte.value, cadena, this.id_hotel, "1").subscribe(data => {
              if(data instanceof HttpResponse) {
                var response = data.body;
                if(response.msg === "PACK_CREATED") {         
                  this.guardado = true;    
                  this.idViaje = response.data.id;   
                  //guardar las imágenes del viaje
                  if(this.imagenes.length > 0 ){
                    this.viajesService.insertarImagen(this.idViaje,'0',this.form2.value).subscribe(data => {    
                      if(data instanceof HttpResponse) {
                        var response = data.body; 
                        if(response.msg === "IMAGENES_SAVED") { 
                          //limpiar formarray de imágenes
                          //this.imagenes.clear();
                          //this.obtenerImagenesBD();
                        }                                               
                      }    
                    });
                  } 
                  const modalRef = this.modalService.open(ModalMsgComponent, { 
                    centered: true,  
                    backdrop:'static',      
                  });
       
                  modalRef.componentInstance.titulo = 'Viaje guardado';
                  modalRef.componentInstance.check = 1; 
                  modalRef.componentInstance.label = 'Volver';
                  modalRef.componentInstance.padre = 'viajes';
                } 
              }     
            });      
          }    
      });
    }  else { 
      if(this.guardado === true && this.idViaje !=='0'){
        //borrar las imagenes del viaje
        //guardar las imágenes del viaje
        if(this.imagenes.length > 0){
          this.viajesService.insertarImagen(this.idViaje,'0',this.form2.value).subscribe(data => {
            if(data instanceof HttpResponse) {
              var response = data.body; 
              if(response.msg === "IMAGENES_SAVED") { 
                //limpiar formarray de imágenes
                //this.imagenes.clear();
                //this.obtenerImagenesBD();                
              }                                               
            }             
          });
        }
        //guardar el hotel
        //this.viajesService.updateHotel(this.id_hotel, this.f1.hotel.value , this.categoria.toString(), this.f1.checkCama.value, this.f1.imagen.value).subscribe(data => {
        this.viajesService.updateHotel(this.id_hotel, this.f1.hotel.value , this.categoria.toString(), this.f1.checkCama.value).subscribe(data => {
          if(data instanceof HttpResponse) {
            //verificar token
            if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
              this.auxService.sessionExpired();
            }
            //acciones 
            this.viajesService.deleteHabitaciones(this.id_hotel).subscribe(data => {
              if(data instanceof HttpResponse) { 
                this.viajesService.insertarHabitaciones(this.id_hotel, list).subscribe(data => {
                  if(data instanceof HttpResponse) {}    
                }); 
              }
            });
          }    
        }); 
        var cadena=this.asientos.join('*');
        this.viajesService.updateAll(this.idViaje, this.f.nombre.value, this.f.descripcion.value, this.f1.destino.value , this.f1.dia.value,this.f1.mes.value, this.f1.anno.value, this.f1.salida.value, this.f1.noches.value,
          this.f1.detalles.value, this.f1.desde.value, this.f1.hasta.value, this.f1.transporte.value, cadena, this.id_hotel, "1").subscribe(data => {
          if(data instanceof HttpResponse) {
            //verificar token
            if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
              this.auxService.sessionExpired();
            }
            //acciones
            const modalRef = this.modalService.open(ModalMsgComponent, { 
              centered: true,  
              backdrop:'static',      
            });
            modalRef.componentInstance.titulo = 'Viaje modificado';
            modalRef.componentInstance.check = 1; 
            modalRef.componentInstance.label = 'Volver';
            modalRef.componentInstance.padre = 'viajes';
          }    
        }); 
      }
    }
    
    this.habilitarControlesOcultos();    

  }

  onCheckboxChange(e) {
    const checkHabitacion: FormArray = this.form2.get('checkHabitacion') as FormArray;
    
    if (e.target.checked) {
      checkHabitacion.push(new FormControl(e.target.value));
      for(let i in this.tipoHabitacion){        
        if(this.tipoHabitacion[i].value == e.target.value){
          this.tipoHabitacion[i].check = true;          
        }        
      }
      
    } else {
      for(let i in this.tipoHabitacion){
        if(this.tipoHabitacion[i].value ==e.target.value){
          this.tipoHabitacion[i].check = false;          
        }        
      }
      
      let i: number = 0;
      checkHabitacion.controls.forEach((item: FormControl) => {
        if (item.value == e.target.value) {
          checkHabitacion.removeAt(i);
          return;
        }
        i++;
      });
    }     
  }
  onCheckboxChange1(e) {
    const checkCama: FormArray = this.form2.get('checkCama') as FormArray;
  
    if (e.target.checked) {
      checkCama.push(new FormControl(e.target.value));   
    } else {
      let i: number = 0;
      checkCama.controls.forEach((item: FormControl) => {
        if (item.value == e.target.value) {
          checkCama.removeAt(i);
          return;
        }
        i++;
      });
    }    
  }

  saveDataTmp(ruta: number){
    //obtener habitaciones
    var list=[]; 
    for (let i in this.tipoHabitacion){
      if(this.tipoHabitacion[i].check){
        if(this.tipoHabitacion[i].name === 'Individual'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Individual.value       
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Doble'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Doble.value         
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Triple'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Triple.value        
          }
          list.push(habitacion);
        }
        if(this.tipoHabitacion[i].name === 'Cuadruple'){
          var habitacion = {
            tipo_habitacion: this.tipoHabitacion[i].value,
            precio: this.f1.Cuadruple.value       
          }
          list.push(habitacion);
        }
      }      
    }
    //this.viajesService.insertarHotel(this.f1.hotel.value , this.categoria.toString(), this.f1.checkCama.value, this.f1.imagen.value).subscribe(data => {
    this.viajesService.insertarHotel(this.f1.hotel.value , this.categoria.toString(), this.f1.checkCama.value).subscribe(data => {
      if(data instanceof HttpResponse) { 
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        this.id_hotel=data.body.data.id;
        this.viajesService.insertarHabitaciones(this.id_hotel, list).subscribe(data => {
          if(data instanceof HttpResponse) { }    
        }); 
        var cadena=this.asientos.join('*');
        var tipoTransporte=(this.f1.transporte.value === 'default')?4:this.f1.transporte.value;
        
        this.viajesService.createData(this.f.nombre.value, this.f.descripcion.value, this.f1.destino.value , this.f1.dia.value,this.f1.mes.value, this.f1.anno.value, this.f1.salida.value, this.f1.noches.value,
          this.f1.detalles.value, this.f1.desde.value, this.f1.hasta.value, tipoTransporte, cadena, this.id_hotel, "2").subscribe(data => {
            if(data instanceof HttpResponse) {
              var response = data.body;
              if(response.msg === "PACK_CREATED") {         
                this.idViaje = response.data.id;  
                //guardar las imágenes del viaje
                if(this.imagenes.length > 0 ){
                  this.viajesService.insertarImagen(this.idViaje,'0',this.form2.value).subscribe(data => {    
                    if(data instanceof HttpResponse) {
                      var response = data.body; 
                      if(response.msg === "IMAGENES_SAVED") { 
                        if(ruta === 1)
                          this.router.navigate(['/', 'admin', 'tour-itinerario', this.idViaje]);   
                        else  this.router.navigate(['/', 'admin', 'tour-excursiones', this.idViaje]);
                      }                                               
                    }    
                  });
                } else {
                  if(ruta === 1)
                    this.router.navigate(['/', 'admin', 'tour-itinerario', this.idViaje]);   
                  else  this.router.navigate(['/', 'admin', 'tour-excursiones', this.idViaje]);
                }                              
              } 
            }     
          });      
        }    
    });  

  }

  navItinerario(){
    //salvar sin validar con estado 0 para obtener el id 
    if (this.guardado === false && this.idViaje==='0'){
      this.saveDataTmp(1);
    } else {      
      this.router.navigate(['/', 'admin', 'tour-itinerario', this.idViaje]);
    }
    
  }
  navExcursiones(){
    //salvar sin validar con estado 0 para obtener el id
    if (this.guardado === false && this.idViaje==='0'){
      this.saveDataTmp(2);
    } else {      
      this.router.navigate(['/', 'admin', 'tour-itinerario', this.idViaje]);
    }    
  }

  hasError(group:FormGroup, control:string) {
    return group.get(control).errors;    
  }
  requiredError(group:FormGroup, control:string) {
     return group.get(control).hasError('required');    
  }
  precioError(group:FormGroup, control:string) {
    return group.get(control).hasError('precioValidator');    
  }
  ngOnDestroy(): void {
    if(this.asientosSubscription){
      this.asientosSubscription.unsubscribe();
    } 
    if(this.categoriaSubscription){
      this.categoriaSubscription.unsubscribe();
    }
  }
  
}
